import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@mui/material';
import { MarketBanner } from '@market/react';
import { EXTENDEND_SHIPPING_QUOTE_TYPES } from 'constants/enums';

const asDays = (num, unit) => {
  switch (unit) {
    case 'days':
    case 'business_days': {
      return num;
    }
    case 'weeks': {
      return num * 7;
    }
    case 'months': {
      return num * 30;
    }
    default: {
      return num;
    }
  }
};

const ShippingBanner = (props) => {
  const { shipQuotes = [] } = props;

  const extendedShipQuotes = shipQuotes.filter((quote) =>
    EXTENDEND_SHIPPING_QUOTE_TYPES.includes(quote.type),
  );

  if (extendedShipQuotes.length === 0) {
    return null;
  }

  const theme = useTheme();
  const { t } = useTranslation();

  let [min, max, unit] = [0, 0, 'days'];
  extendedShipQuotes.forEach((itemData) => {
    // in case we are comparing weeks to months we convert everything to days
    if (asDays(itemData.min, itemData.unit) > asDays(min, unit)) {
      [min, max, unit] = [itemData.min, itemData.max, itemData.unit];
    }
  });
  const timeUnit = t(`shipping.shippingEstimate.timeUnits.${unit}.other`);

  return (
    <MarketBanner variant="warning" style={{ margin: theme.spacing(2, 0) }}>
      <p className="medium-30">
        {t('checkout.shippingEstimate.extendedNotice.text', {
          min,
          max,
          timeUnit,
        })}
      </p>
      <p>{t('checkout.shippingEstimate.extendedNotice.subtext')}</p>
    </MarketBanner>
  );
};

export default ShippingBanner;
